<template>
  <div>
    <div class="report-loader text-center mb-5" v-if="loadingPreview">
      <img src="/images/loading.gif" />
    </div>
    <div v-else>
      <div class="justify-content-center">
        <div
          class="file-selection-bar consulting-bar file-selection-bar_two-col"
          style="clear: left"
        >
          <template v-if="consulting_slug !== 'customized-report'">
            <!--live report navigation bar-->
            <div class="report-title">
              <select
                name="report-page"
                id="report-page"
                v-on:input="selectPage($event)"
              ></select>
            </div>
          </template>
          <div class="report-files">
            <template v-if="report.downloads.pdf">
              <a
                :href="'/storage/' + report.downloads.pdf"
                title="Download PDF"
              >
                <img
                  :src="'/images/icons/icon-pdf.svg'"
                  alt="File"
                  title="Download PDF"
                />
              </a>
            </template>
            <template v-else-if="consulting_slug === 'customized-report'">
              <a
                id="customized-report-link"
                href=""
                title="Download PDF"
                download
              >
                <img
                  :src="'/images/icons/icon-pdf.svg'"
                  alt="File"
                  title="Download PDF"
                />
              </a>
            </template>
            <template
              v-else-if="
                (report.live_report_id !== '' &&
                  report.live_report_id !== '0' &&
                  report.live_report_id !== null) ||
                selected === live_id
              "
            >
              <a
                class="vue-anchor"
                v-on:click="downloadPDF()"
                title="Download PDF"
              >
                <img
                  :src="'/images/icons/icon-pdf.svg'"
                  alt="File"
                  title="Download PDF"
                />
              </a>
            </template>
          </div>
        </div>
      </div>
      <template v-if="consulting_slug === 'customized-report'">
        <CustomizedReportComponent
          :app_url="app_url"
          :reportID="report.id"
          :apiID="report.live_report_id"
        />
      </template>
      <template
        v-else-if="
          report.live_report_id !== '' &&
          report.live_report_id !== '0' &&
          report.live_report_id !== null
        "
      >
        <!-- <template v-if="report.live_report_id !== '' && report.live_report_id !== '0' && report.live_report_id !== null"> -->
        <LiveReportParentComponent
          ref="live_report_parent"
          :live_id="live_id"
          :report_id="report.live_report_id"
          :consulting_slug="consulting_slug"
          :reportAddOns="report_add_ons"
          :report360="report_360"
          :preview="true"
          :ondemand_report_id="report.id"
          :reportTypeId="report_type_id"
        />
      </template>
      <div v-else>
        <!-- Not a live report, load PDF -->
        <div>
          <template v-if="!safarimobile">
            <div class="iframeEmbed insiderIframe--wrapper" id="google">
              <iframe
                class="insiderIframe"
                :src="'/storage/' + report.downloads.pdf"
              ></iframe>
            </div>
          </template>
          <template v-else>
            <!--use the google renderer-->
            <!-- <p><a :href="'/storage/' + report.downloads.pdf" class="button-green">Download PDF</a></p> -->
            <div class="iframeEmbed insiderIframe--wrapper" id="google">
              <iframe
                :src="
                  'https://docs.google.com/viewer?url=' +
                  app_url +
                  '/storage/' +
                  report.downloads.pdf +
                  '&embedded=true'
                "
                style="width: 100%; height: 100%"
                frameborder="0"
              ></iframe>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LiveReportParentComponent from '~/components/report/modules/live-report/LiveReportParentComponent.vue';
  import CustomizedReportComponent from '~/components/report/modules/live-report/customized-report/CustomizedReportComponent.vue';

  export default {
    components: {
      LiveReportParentComponent,
      CustomizedReportComponent,
    },
    props: {
      report_id: {
        type: Number,
        required: false,
      },
      live_id: {
        type: Number,
        required: true,
      },
      consulting_slug: {
        type: String,
        required: true,
      },
      app_url: {
        type: String,
        required: true,
      },
      reportobj: {
        type: String,
        required: true,
      },
      report_add_ons: {
        type: Array,
        required: true,
      },
      report_360: {
        type: Boolean,
        required: true,
      },
      report_type_id: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        loadingPreview: true,
        safarimobile:
          navigator.userAgent.match(/(iPod|iPhone|iPad)/) &&
          navigator.userAgent.match(/AppleWebKit/),
        pageIndex: 0,
        report: {
          id: '',
          name: '',
          data_file: '',
          downloads: {
            doc: '',
            xls: '',
            pdf: '',
            ppt: '',
          },
          iframe: '',
          live_report_id: '',
        },
      };
    },
    mounted() {
      let data = JSON.parse(this.reportobj);
      this.report = {
        id: data.id,
        name: data.pdf_file_name,
        data_file: data.data_attachment,
        downloads: {
          doc: data.doc_attachment,
          xls: data.xls_attachment,
          pdf: data.pdf_attachment,
          ppt: data.ppt_attachment,
          vimeo: data.vimeo_id,
        },
        iframe: '',
        live_report_id: data.live_report_id,
      };
      this.loadingPreview = false;
    },
    methods: {
      selectPage: function (event) {
        var selectedPage = event.target.value;
        var pageIndex =
          event.target[event.target.selectedIndex].getAttribute('index') ?? 0;

        if (selectedPage === 'division' || selectedPage === 'indicator') {
          selectedPage = selectedPage + pageIndex;
        }

        document.getElementById(selectedPage).scrollIntoView();
      },
      downloadPDF() {
        this.$refs.live_report_parent.downloadPDF();
      },
    },
  };
</script>
